module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/result02_sp-724bada6b5ddd7826966261c00167c18.png";